export const navbarDatas = [
    {
        id: 1,
        link: 'Home'
    },
    {
        id: 2,
        link: 'About'
    },
    {
        id: 3,
        link: 'Portfolio'
    },
    {
        id: 4,
        link: 'Experience'
    },
    {
        id: 5,
        link: 'Contact'
    },
]